import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "./navigation";
import api from "./api/api";
import { ENDPOINTS } from "./api/endpoints";

const RoleStatus = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [filteredRoles, setFilteredRoles] = useState([]);
  const [projectTitle, setProjectTitle] = useState(""); 
  const [submittedDate, setSubmittedDate] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const noticeId = location.state?.noticeId;
  const userId = localStorage.getItem("userId");
  const email = localStorage.getItem("email");

  
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);

        // Fetch roles
        const rolesResponse = await api.get(
  ENDPOINTS.getRoleDetails({ noticeId, page: 1, pageSize: 10 })
);
        if (!rolesResponse.ok) throw new Error("Failed to fetch roles");
        const rolesData = await rolesResponse.json();
        if (rolesData.data.items) {
          setRoles(rolesData.data.items);
          setFilteredRoles(rolesData.data.items);
        }

        // Fetch project details
        const projectResponse = await api.get(
  ENDPOINTS.getNoticeDetails({ email, noticeId, page: 1, pageSize: 50 })
);
        if (!projectResponse.ok) throw new Error("Failed to fetch project details");
        const projectData = await projectResponse.json();

        if (projectData.data && projectData.data.length > 0) {
          setProjectTitle(projectData.data[0].projectTitle || "N/A");
          setSubmittedDate(projectData.data[0].noticeCreatedDate || "N/A");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [noticeId]);



  const handleFilterChange = (status) => {
    setStatusFilter(status);
    if (status === "All") {
      setFilteredRoles(roles);
    } else {
      setFilteredRoles(roles.filter((role) => role.status === status));
    }
  };
  const handleEdit = (role) => {
    navigate("/role-creator", { state: { role, noticeId } });
  };
  const handlePreview = () => {
    navigate("/SummaryDetails", { state: { noticeId: noticeId } });
  };

  /*  const handleSearchChange = (event) => {
     const term = event.target.value;
     setSearchTerm(term);
     setFilteredRoles(
       roles.filter((role) =>
         role.title.toLowerCase().includes(term.toLowerCase())
       )
     );
   }; */

  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <>
      <Navbar />
      <div style={{ padding: "2rem", maxWidth: "1200px", margin: "auto" }}>
        <h2 style={{ margin: "20px 0" }}>Role Status</h2>

        {/* Search */}
        <div style={{ flex: "3" }}>
          <input
            type="text"
            placeholder="Search casting calls..."
            value={searchTerm}
            style={{
              width: "100%",
              padding: "0.5rem",
              borderRadius: "5px",
              border: "1px solid #ddd",
            }}
          />
        </div>
        {/* <div style={{ flex: "3" }}>
          <input
            type="text"
            placeholder="Search casting calls..."
            value={searchTerm}
            onChange={handleSearchChange}
            style={{
              width: "100%",
              padding: "0.5rem",
              borderRadius: "5px",
              border: "1px solid #ddd",
            }}
          />
        </div> */}

        {/* Filters */}
        <div style={{ display: "flex", padding: "20px 0" }}>
          <div
            style={{
              flex: "1",
              display: "flex",
              gap: "1rem",
              backgroundColor: "#eee",
              marginRight: "15px",
              padding: "20px",
            }}
          >
            <div>
              <h4 style={{ marginBottom: "5px", fontWeight: "500" }}>Filters</h4>
              {["All", "Pending", "Accepted", "Rejected"].map((status) => (
                <div key={status} style={{ margin: "3px 0" }}>
                  <label>
                    <input
                      type="radio"
                      name="status"
                      value={status}
                      checked={statusFilter === status}
                      onChange={() => handleFilterChange(status)}
                    />
                    {status}
                  </label>
                </div>
              ))}
            </div>
          </div>

          {/* Role Cards */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem", flex: "8" }}>
            {filteredRoles.map((role, index) => (
              <div
                key={role.id}
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "5px",
                  padding: "1rem",
                  width: "300px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                {/* Added Project Title & Submitted Date */}
                <li key={index} className="" style={{ listStyleType: "none" }}>
                  <strong>{role.roleName}</strong>
                  <div className="generalMarginSeconday">
                    <div><span>Production: {projectTitle}</span></div>
                    {/* <div><span>Submitted on: {submittedDate ? new Date(submittedDate).toLocaleDateString() : "N/A"}</span></div>*/}
                    <div><span>
                      Submitted on:{" "}
                      {submittedDate
                        ? new Date(submittedDate).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })
                        : "N/A"}
                    </span></div>
                  </div>
                </li>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  {role.status === "Accepted" && (
                    <span style={{ color: "green", fontWeight: "bold" }}>✔ Accepted</span>
                  )}
                  {role.status === "Pending" && (
                    <span style={{ color: "orange", fontWeight: "bold" }}>⌛ Pending</span>
                  )}
                  {role.status === "Rejected" && (
                    <span style={{ color: "red", fontWeight: "bold" }}>✖ Rejected</span>
                  )}
                </div>

                {/* Action Buttons */}
                <div style={{ display: "flex", gap: "0.5rem" }}>
                  <button
                    style={{
                      flex: 1,
                      padding: "0.5rem",
                      background: "white",
                      color: "black",
                      border: "1px solid #90b5fe",
                      borderRadius: "5px",

                    }}
                    onClick={() => handlePreview()}
                  >
                    Preview
                  </button>
                  {role.status === "Rejected" ? (
                    <button
                      style={{
                        flex: 1,
                        padding: "0.5rem",
                        background: "red",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                      }}
                    >
                      Re-submit
                    </button>
                  ) : (
                    <button
                      style={{
                        flex: 1,
                        padding: "0.5rem",
                        background: "#90b5fe",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                      }}
                      onClick={() => handleEdit(role)}
                    >
                      Edit
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default RoleStatus;
